import { Link } from "react-router-dom";

export default function EventosAtivos() {
  const eventos = [

        {
      id: "EntreNos",
      nome: "Entre Nós",
      imagem: "/imagens/BannerEntreNos.png",
      local: "Itajaí - SC",
      datas: "07 a 10 de novembro",
      horarios: [
        "Confirme no site oficial",
      ],
      ativo: true,
    },
    {
      id: "feinsul-2026",
      nome: "Feira Home&Decor da Feinsul",
      imagem: "/imagens/preto.png",
      local: "Joinville - SC", 
      datas: "16 a 18 de Outubro",
      horarios: [
        "sexta-feira (16/10): 14:00 - 21:00",
        "Sábado (17/10): 10:00 - 21:00",
        "Domingo (18/10): 10:00 - 20:00",
      ],
      ativo: false,
    },
  ];

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/textura-hexagono-azul.png")' }}
    >
      <div className="page">
        {eventos
          .filter((evento) => evento.ativo)
          .map((evento) => (
            <div key={evento.id} className="card">
              <span className="badge">ATIVO!</span>
            {
              <div className="card-image-wrapper">
                <img
                  src={evento.imagem}
                  alt={evento.nome}
                  className="card-image"
                />
              </div>
            }

              <h3 className="card-title">{evento.nome}</h3>
              <div className="card-local">{evento.local}</div>

              <div className="card-info">
                <p><strong>DATA:</strong></p>
                <ul>
                  <li><strong>{evento.datas}</strong></li>
                </ul>

                <div className="horarios">
                  <p><strong>HORÁRIOS:</strong></p>
                  <ul>
                    {evento.horarios.map((h, i) => (
                      <li key={i}><strong>{h}</strong></li>
                    ))}
                  </ul>
                </div>
              </div>
            {
            <Link to={`/evento/${evento.id}`} className="link-button">
              Cadastre-se
            </Link>
            }
            </div>
          ))}
      </div>
    </div>
  );
}